import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type ResponseUpdateAvatar = {
  img: string;
};

export const updateAvatar = async (blob: Blob) => {
  const formData = new FormData();

  formData.append('file', blob, `avatar.webp`);

  const response = await axios.post(
    `${rootUrl}/psychologist/update/avatar?token=${getCookies('auth')}`,
    formData
  );

  return response.data;
};
